import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "data-to"]

import { ref, reactive, onMounted } from 'vue';

    /* interface */
    interface Props {
        url: string,
        to?: string

    }
    interface State {
        url: string,
        fallbackImage: boolean
    }

    /* Ref */
    
export default /*#__PURE__*/_defineComponent({
  __name: 'ArticleImage',
  props: {
    url: null,
    to: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
        url: string,
        to?: string

    };

    /* imports */
    const image = ref<HTMLImageElement>();

    /* Reactive */
    const state = reactive<State>({
        url: '',
        fallbackImage: false
    });

    /* Const */
    const fallbackImageUrl = '/assets/img/444x250_Default.png';

    /* Props */
    

    /* Fuinctions */
    const setFallbackImg = () => {
        state.url = fallbackImageUrl;
        
    };

    const addToOrder = () => {

        return new Promise((resolve: any, reject: any) => {
            
            if (image.value) {

                const order = document.querySelector('.order__content');

                if (!order) {
                    reject("element order_content is missing!")
                }

                const el: Element | null | undefined = props.to ? order?.querySelector(`[data-id=a-${props.to}]`) || order : order?.querySelector('li:last-child') || order;

                if (el) {

                    const rectOrder: DOMRect = el.getBoundingClientRect();

                    const rectImage: DOMRect = image.value.getBoundingClientRect();

                    const img = new Image(rectImage.width, rectImage.height);

                    const sizeRatio = 100 / rectImage.width;

                    img.addEventListener('transitionend', () => {
                        img.remove();
                        setTimeout(() => {
                            if (image.value) {
                                image.value.style.removeProperty('opacity');
                            }
                        }, 250);
                        resolve(true);
                    });

                    img.className = 'clone';

                    const styleStart = {
                        top: `${rectImage.top}px`,
                        left: `${rectImage.left}px`
                    }

                    const styleEnd = {
                        top: `${rectOrder.top}px`,
                        left: `${rectOrder.left}px`,
                        transform: `scale(${sizeRatio})`
                    }

                    img.onerror = (err) => {
                        reject(err);
                    };

                    img.src = image.value.src;
                    Object.assign(img.style, styleStart);

                    if (image.value) {
                        image.value.style.opacity = '0.1';
                    }

                    document.body.appendChild(img);
                    setTimeout(() => {
                        Object.assign(img.style, styleEnd);
                        img.classList.add('clone--animate')
                    }, 10);

                } else {
                    reject("element is missing!")
                }
            }
        });
    };

    expose({
        addToOrder
    });

    /* Lifecycle Hooks */
    onMounted(() => {

        if (props.url.length) {
            state.url = `/api/images/${props.url}`;
        } else {
            state.fallbackImage = true;
            state.url = fallbackImageUrl;
        }
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: state.url,
    ref_key: "image",
    ref: image,
    "data-to": props.to,
    onErrorOnce: setFallbackImg,
    class: _normalizeClass({ 'fallback-image': state.fallbackImage, 'custom-image': !state.fallbackImage }),
    alt: ""
  }, null, 42, _hoisted_1))
}
}

})